import { GlobalAppState } from '@model/state';
import { RequestType } from './loadingOperations';

export const getLoading = (type: RequestType) => (state: GlobalAppState) => state.app.loading[type] || false;
